<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)" :key="idDelModelo">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de distorsión de audio</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de distorsiones de audio</option>
        <option v-for="TipoDistorsionDeAudio in TiposDistorsionesDeAudio" :value="TipoDistorsionDeAudio.TipoDistorsionDeAudioId">{{TipoDistorsionDeAudio.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposDistorsionesDeAudio: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_Forseti_Catalogo_Establecer015TipoDistorsionDeAudio", parametros);
    },
    computed: {
      idDelModulo() {
        this.idDelModelo = this.$store.state.Forseti_Catalogos_015TiposDistorsionesDeAudio[this.idDelInput];
        return this.$store.state.Forseti_Catalogos_015TiposDistorsionesDeAudio[this.idDelInput];
      }
    },
    methods: {
      cargaCatalogoTiposDistorsionesDeAudio() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.Forseti.catalogos.C015TiposDistorsionesDeAudio, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.TiposDistorsionesDeAudio = respuesta.data.TiposDistorsionesDeAudio;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_Forseti_Catalogo_Establecer015TipoDistorsionDeAudio", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposDistorsionesDeAudio();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/Catalogos/015TiposDistorsionesDeAudio.vue